<table class="custom-table-list" aria-label="cred_table">
  <thead>
    <tr class="custom-table-list-headings">
      <th class="custom-col-width-30">Category Name</th>
      <th class="custom-col-width-30">Metadata Fields</th>
      <th class="custom-col-width-20">Allowed File Format</th>
      <th class="custom-col-width-20">Action</th>
    </tr>
  </thead>
  <tbody>
    @for ( value of documenttypelist; track  value) {
      <tr class="custom-table-list-row-main">
        <td class="custom-col-width-30">{{value?.name}}</td>
        <td class="custom-col-width-30" >{{getMetaDataFields(value?.assignedLookups)}}</td>
        <td class="custom-col-width-20" >
          @if (fileExtensionData?.enabledExtensions?.length) {
            <span>
              {{getAvailableExtensionCount(fileExtensionData.enabledExtensions, value?.allowedExtensions)}}
            </span>
          }
        </td>
        <td class="custom-col-width-20">
          <span class="d-flex justify-content-start">
            @if (!value.ocrCategory) {
              <span (click)="onEditDocumentType(value, 'view')" data-bs-toggle="tooltip" ngbTooltip="Metadata Fields" [placement]="'left'">
                <div class="btn btn-primary btn-sm me-2 fa-icon-class" style="background-color: #de7141; border-color: #de7141;">
                  <fa-icon [icon]="faEye"></fa-icon>
                </div>
              </span>
            }
            @if (tabvalue === 'documenttype') {
              <span (click)="onEditDocumentType(value, 'editExt')" data-bs-toggle="tooltip" ngbTooltip="File Types"
                [placement]="'left'">
                <div class="btn btn-primary btn-sm me-2 fa-icon-class" style="background-color: #de7141; border-color: #de7141;">
                  <fa-icon [icon]="faFile"></fa-icon>
                </div>
              </span>
            }
            @if (tabvalue === 'documenttype') {
              <span (click)="onEditDocumentType(value, 'dynamicRegex')" data-bs-toggle="tooltip" ngbTooltip="Doc Format"
                [placement]="'left'">
                <div class="btn btn-primary btn-sm me-2 fa-icon-class" style="background-color: #de7141; border-color: #de7141;">
                  <fa-icon [icon]="faChain"></fa-icon>
                </div>
              </span>
            }
            <span (click)="onEditDocumentType(value)" data-bs-toggle="tooltip"
              ngbTooltip="Edit" [placement]="'left'">
              <div tooltipClass="custom-tooltip" class="btn btn-primary btn-sm me-2"
                style="background-color: #de7141; border-color: #de7141;">
                <fa-icon [icon]="faEdit"></fa-icon>
              </div>
            </span>
            @if (tabvalue === 'contracttype' || tabvalue === 'recordtype') {
              <span (click)="onEditDocumentType(value, 'DELETE')" data-bs-toggle="tooltip" ngbTooltip="DELETE" [placement]="'left'">
                <div class="btn btn-primary btn-sm me-2 fa-icon-class" style="background-color: #de7141; border-color: #de7141;">
                  <fa-icon [icon]="faTrash"></fa-icon>
                </div>
              </span>
            }
          </span>
        </td>
      </tr>
    }
  </tbody>
</table>
@if (isDocumentType) {
  <div class="overlay" [class.show]="isDocumentType"></div>
}
@if (isDocumentType) {
  <div class="off-canvas {{formType === 'edit' ? 'width-450' : 'width-640'}}" [class.show]="isDocumentType">
    @if (formType === 'edit') {
      <div class="off-canvas-content">
        <app-add-document-type [hasEditAccess]="hasEditAccess" [tabvalue]="tabvalue" [documentType]="documentType" (closePanel)="onCloseIconClick($event)" (submitForm)="onSubmit($event)"></app-add-document-type>
      </div>
    }
    @if (formType === 'dynamicRegex') {
      <div class="off-canvas-content">
        <app-custom-regex [hasEditAccess]="hasEditAccess" [documentType]="documentType" (save)="updateRegex($event)" (closePanel)="onCloseIconClick($event)"></app-custom-regex>
      </div>
    }
    @if (formType === 'editExt') {
      <div class="off-canvas-content">
        <app-file-extensions [hasEditAccess]="hasEditAccess" [verifyLoader]="verifyLoader" (save)="updateExtensions($event)" [preferencesData]="enabledExtensions" (closePanel)="onCloseIconClick($event)"></app-file-extensions>
      </div>
    }
  </div>
}
@if (isToaster) {
  <div class="toaster_message">
    <app-toast [title]="uploadErrorMessage" (closeToaster)="closeToster($event)" ></app-toast>
  </div>
}
